var index = 1;
var Fragment = function (options) {
  this.options = options;
  this.id = 'fragment_' + index++;
};

Fragment.prototype = {
  getCurrentPosition: function () {
    var top, left;
    if (this.options.spend <= this.options.dur) {
      top = this.options.begin.top - (this.options.begin.top - this.options.end.top) * this.options.spend / this.options.dur;
      left = this.options.begin.left - (this.options.begin.left - this.options.end.left) * this.options.spend / this.options.dur;
    } else {
      top = this.options.end.top;
      left = this.options.end.left;
    }
    return {
      top: top,
      left: left
    };
  },
  updateSpend: function (time) {
    this.options.spend = this.options.spend + time;
  }
};

module.exports = Fragment;


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.barrage.mobile/app/modules/canvas/fragment.js